import { render, staticRenderFns } from "./CustomersPanel.vue?vue&type=template&id=abe780fa&"
import script from "./CustomersPanel.vue?vue&type=script&lang=js&"
export * from "./CustomersPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports